export const initialState = {
  SearchList: [],
  SearchQuery: "",
  SearchComplete: false
};
